import * as salesActions from '../sales/actionTypes'
let actions = {}
for(let actionName of Object.keys(salesActions)){ // eslint-disable-line
  actions[actionName] = `acquiring/${actionName}`
}
export default actions
